/**
 * Decides whether current library should be logging.
 * @param {String} paramValue Value of debug UTM
 * @param {*} name Name of current library
 * @return {Boolean} Should log or not
 */
const getShouldLog = (paramValue, name) => {
    // empty string, or any falsey
    if (!paramValue) {
        return false;
    }
    // if paramValue === "1" always log
    if (paramValue === '1') {
        return true;
    }
    // if paramValue contains "!" allowed libraries are defined by exclusion
    if (~paramValue.indexOf('!')) {
        if (~paramValue.toLowerCase().indexOf(`!${name.toLowerCase()}`)) {
            return false;
        }
        return true;
    }
    // if paramValue isn't "1" and contains name - should log
    if (~paramValue.toLowerCase().indexOf(name.toLowerCase())) {
        return true;
    }
    // did not fit any category - should NOT log
    return false;
};
export { getShouldLog };
